
import { css } from 'lit';
export default css`
:host{
  --topic-card-border:2px solid var(--purple-medium-neutral);
  display:block;
}

.topic-card{
  position:relative;
  display:flex;
  flex-direction:column;
  height:100%;
}

.topic-card .topic-card--content{
    display:flex;
    flex-direction:column;
    transition:all 0.3s ease 0s;
    border-right:var(--topic-card-border);
    border-bottom:var(--topic-card-border);
    border-left:var(--topic-card-border);
    border-radius:0px 0px 32px 0px;
    padding:var(--spacing-6);
    overflow:hidden;
    height:100%;
  }

.topic-card .topic-card--cta-wrapper{
    margin-top:auto;
  }

.topic-card:hover .topic-card--content{
  border-color:var(--neutral-light);
  background:var(--neutral-light);
}
`;